import React, { Component } from "react";

export default class TheButton extends Component {
  render() {
    const buttonStyle = {
      borderRadius: 5,
      padding: 10,
      background: "#337ab7",
      marginLeft: 15,
      color: "white",
      border: "none",
      width: 90,
      ...this.props.style,
    };
    return (
      <button onClick={this.props.onClick} style={buttonStyle}>
        {this.props.label}
      </button>
    );
  }
}
